const initialState = {
    itemList: {
        today: {
            isInitiated: false,
            isLoading: false,
            list: [],
            page: 1,
            lastPage: 1
        },
        forReview: {
            isInitiated: false,
            isLoading: false,
            list: [],
            page: 1,
            lastPage: 1
        },
        forApproval: {
            isInitiated: false,
            isLoading: false,
            list: [],
            page: 1,
            lastPage: 1
        },
        delayed: {
            isInitiated: false,
            isLoading: false,
            list: [],
            page: 1,
            lastPage: 1
        },
        files: {
            isInitiated: false,
            isLoading: false,
            list: [],
            page: 1,
            lastPage: 1
        }
    },
    my_conversations:{
        list:[],
        count:{}
    },
    sorting: {
        column: "subject",
        order: "desc"
    }
}

export default function reducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case "UPDATE_STATUS_TASK_LIST": 
            return {
                ...state,
                itemList: {
                    ...state.itemList,
                    [action.status]: {
                        ...state.itemList[action.status],
                        list: action.list
                    }
                }
            }

        case "UPDATE_STATUS_TASK_LOADING":
            return {
                ...state,
                itemList: {
                    ...state.itemList,
                    [action.status]: {
                        ...state.itemList[action.status],
                        isLoading: action.boolean
                    }
                }
            }

        case "UPDATE_STATUS_TASK_INITIATED":
            return {
                ...state,
                itemList: {
                    ...state.itemList,
                    [action.status]: {
                        ...state.itemList[action.status],
                        isInitiated: action.boolean
                    }
                }
            }

        case "UPDATE_STATUS_TASK_PAGE":
            return {
                ...state,
                itemList: {
                    ...state.itemList,
                    [action.status]: {
                        ...state.itemList[action.status],
                        page: action.page
                    }
                }
            }
        
        case "UPDATE_STATUS_TASK_LAST_PAGE":
            return {
                ...state,
                itemList: {
                    ...state.itemList,
                    [action.status]: {
                        ...state.itemList[action.status],
                        lastPage: action.page
                    }
                }
            }
        case "MY_CONVERSATION_LIST":
            return {
                ...state,
                my_conversations: {list:action.list, ...(action.count?{count: action.count}:{})}
            }
        
        case "MY_CONVERSATION_SORT":
            return {
                ...state,
                sorting:  action.sorting
            }
        default:
            return state;
    }
}
